// -----------------------------------------------------------
// FloraIQ - DeliverablesGrid (Aba Produtos e Entregáveis)
// -----------------------------------------------------------

import { useState } from "react";
import { deliverables } from "@/mocks/operational";

const statusStyles: Record<string, string> = {
  "Gerado": "bg-green-100 text-green-700 border-green-200",
  "Em geração": "bg-accent-100 text-accent-700 border-accent-200",
  "Pendente": "bg-orange-100 text-orange-700 border-orange-200",
  "Em revisão": "bg-yellow-100 text-yellow-700 border-yellow-200",
};

export default function DeliverablesGrid() {
  const [filter, setFilter] = useState("");

  const filtered = filter ? deliverables.filter((d) => d.status === filter) : deliverables;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 flex-wrap">
        {["", "Gerado", "Em geração", "Pendente", "Em revisão"].map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`text-xs px-3 py-1.5 rounded-full cursor-pointer transition-colors whitespace-nowrap ${
            filter === s ? "bg-primary-500 text-white" : "bg-background-100 text-foreground-600 hover:bg-background-200"
          }`}>
            {s || "Todos"}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {filtered.map((d) => (
          <div key={d.id} className="rounded-card border border-background-200/70 p-4 hover:border-primary-200 transition-colors group">
            <div className="flex items-start justify-between mb-2">
              <div className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center">
                <i className={`${d.tipo === "Dados GIS" || d.tipo === "Dados 3D" ? "ri-database-2-line" : d.tipo === "Mapa" || d.tipo === "Mapa Temático" ? "ri-map-pin-line" : d.tipo === "Dashboard" ? "ri-bar-chart-box-line" : d.tipo === "Modelo 3D" ? "ri-stack-line" : "ri-file-text-line"} text-foreground-600 text-sm`}></i>
              </div>
              <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium border whitespace-nowrap ${statusStyles[d.status] || "bg-background-100 text-foreground-600"}`}>
                {d.status}
              </span>
            </div>
            <h5 className="text-sm font-bold text-foreground-900 mb-1">{d.titulo}</h5>
            <p className="text-xs text-foreground-500 mb-2 line-clamp-2">{d.descricao}</p>
            <div className="flex items-center justify-between text-[10px] text-foreground-400 pt-2 border-t border-background-100/70">
              <span>{d.formato}</span>
              <span>{d.ultimaAtualizacao !== "-" ? d.ultimaAtualizacao : "Pendente"}</span>
            </div>
            <div className="flex items-center gap-1.5 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
              <button className="flex-1 text-xs bg-primary-500 text-white px-2 py-1.5 rounded-md cursor-pointer whitespace-nowrap">
                <i className="ri-eye-line mr-1"></i>Visualizar
              </button>
              <button className="text-xs bg-background-100 text-foreground-600 px-2 py-1.5 rounded-md cursor-pointer whitespace-nowrap hover:bg-background-200">
                <i className="ri-download-line mr-1"></i>Exportar
              </button>
            </div>
          </div>
        ))}
      </div>

      <p className="text-xs text-foreground-400">Mostrando {filtered.length} de {deliverables.length} produtos</p>
    </div>
  );
}